<div class="row">
    <div class="col-12">
        <!--FuelWidget-->
        <div class="row pt-3">
            <div class="col-md-3 col1" align="center">
                <h2>{{fuelYearly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                    <h5>Total year to date</h5>
                    <p>___________________</p>
                    <font *ngIf="!fuelYearly">NO RECORD FOR YEAR TO DATE</font>
                    <font  *ngIf="fuelYearly">TOTAL FUEL COST FOR YEAR TO DATE<br /></font>
                    <br />
            </div>

            <div class="col-md-3 col2" align="center">
                <h2>{{fuelMonthly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                    <h5>Total this month</h5>
                    <p>___________________</p>
                    <font *ngIf="fuelMonthly == 0">NO RECORD FOR THE CURRENT MONTH</font>
                    <font *ngIf="fuelMonthly > 0">TOTAL FUEL COST FOR THE CURRENT MONTH</font>
                    <br />
            </div>

            <div class="col-md-3 col3" align="center">
                <h2>{{fuelWeekly | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                    <h5>Total this week</h5>
                    <p>___________________</p>
                    <font *ngIf="fuelWeekly == 0">NO RECORD FOR THE CURRENT WEEK</font>
                    <font *ngIf="fuelWeekly > 0">TOTAL FUEL COST FOR THE CURRENT WEEK</font>
                    <br />
            </div>

            <div class="col-md-3 col4" align="center">
                <h2>{{fuelRecentCost | currency:'USD':'symbol'}} <i class="fa fa-line-chart"></i></h2>
                    <h5>Latest Fuel Cost</h5>
                    <p>___________________</p>
                    <font *ngIf="fuelRecentCost == 0">NO RECENT RECORD</font>
                    <font *ngIf="fuelRecentCost != 0"> FUEL FOR {{fuelRecentRego}} ON {{ (fuelRecentDate !== null) && (fuelRecentDate !== "NONE") ? (fuelRecentDate | date: 'dd MMM yyyy') : "UNRECORDED DATE"  }}</font>
                    <br />
            </div>
        </div>
        <br/>
        <div class="clearfix">
            <ul class="nav nav-tabs custom top">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="tab" href="#tabFuels"><strong>Fuel Costs</strong></a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="tab" href="#tabItems"><strong>Fuel Items</strong></a>
                </li>
            </ul>
        </div>
        <div class="tab-content top">
            <!-- TAB A -->
            <div class="tab-pane active" id="tabFuels">
                <div class="row pt-0">
                    <div class="col-md-12">
                        <!-- sub menu-->
                        <button type="button" class="btn btn-secondary btn-sm mb-1 mr-1" aria-expanded="false"
                            ngbTooltip="Add New Fuel" placement="bottom" (click)="openFuelModal(null)">
                            <span class="sr-only">Add</span>
                            <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Add</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1"  (click)="printer.printWithHeaderFooter('print-section-fuel', 'Fuel List')" [disabled]="fuelCount < 1"
                            placement="bottom" ngbTooltip="Print List">
                            <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Print</span>
                        </button>

                        <div class="btn-group mr-1">
                            <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="fuelCount < 1">
                                <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Export</span>
                            </button>
                            <div class="dropdown-menu fs-12">
                                <a (click)="fuelCost_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                                <a (click)="fuelCost_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a>
                                <a (click)="fuelCost_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                            </div>
                        </div>

                        <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                            (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                            <i class="fa fa-lg fa-filter"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Filter</span>
                        </button>
                        <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                            (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
                            <i class="fa fa-lg fa-toggle-right"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp;Sidebar</span>
                        </button>

                            <div class="btn-group mb-1">
                                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                    placement="bottom" ngbTooltip="Show/Hide Columns">
                                    <span class="sr-only">Toggle Dropdown</span>
                                    <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                                </button>
                                <div class="dropdown-menu fs-12" style="width: 150px;">
                                    <div class="col-md-12 mb-3 fs-12">
                                        <input type="checkbox" [(ngModel)]="showDate" > Date<br />
                                        <input type="checkbox" [(ngModel)]="showWeekNo"> Week No.<br />
                                        <input type="checkbox" [(ngModel)]="showRego" *ngIf="!fleet_id"> <span *ngIf="!fleet_id">REGO<br /></span>
                                        <input type="checkbox" [(ngModel)]="showFleetID" *ngIf="!fleet_id"> <span *ngIf="!fleet_id">Fleet ID<br /></span>
                                        <input type="checkbox" [(ngModel)]="showDriver"> Driver<br /> 
                                        <input type="checkbox" [(ngModel)]="showSupplier"> Supplier<br />
                                        <input type="checkbox" [(ngModel)]="showCardNo"> Card No.<br />
                                        <input type="checkbox" [(ngModel)]="showCost"> Cost<br />
                                        <input type="checkbox" [(ngModel)]="showLitres"> Litres<br />
                                        <input type="checkbox" [(ngModel)]="showFile"> File<br />
                                    </div>
                                </div>
                            </div>

                            <span *ngIf="myDropDown=='range'" class="pull-right" >&nbsp;
                                <input type="text"   width="120" class="mb-1" class="dateRangeInput" matInput
                                ngxDaterangepickerMd
                                [locale]="locale"
                                startKey="start"
                                endKey="end"
                                [showWeekNumbers]="true"
                                [showDropdowns]="true"
                                [(ngModel)]="fuelDateRange"
                                (ngModelChange)="processFuelDateRange($event)"
                                name="daterange" 
                                [autoApply]="true"
                                opens="left"
                                drops="down"
                                [maxDate]="maxDate"
                                />
                            </span>
                           
                            <select [(ngModel)]="myDropDown" (ngModelChange)="onChangeofOptions($event)" class="dateFilter  btn btn-sm  btn-secondary mb-1 pull-right">
                                        <option value="today">Today</option>
                                        <option value="week">This Week</option>
                                        <option value="month">This Month</option>
                                        <option value="year">This Year</option>
                                        <option value="7">Last 7 days</option>
                                        <option value="14">Last 14 days</option>
                                        <option value="30">Last 30 days</option>
                                        <option value="90">Last 90 days</option>
                                        <option value="all">All Dates</option>
                                        <option value="range">Custom date range</option>
                                </select>
                        <!-- end sub menu -->
                        <!-- filter -->
                        <br *ngIf="showFilters" />
                        <div class="row" *ngIf="showFilters">
                            <div class="col-md-12">
                                <div widget class="card border-0">
                                    <div class="card-header border-0 text-muted">
                                        <h5 class="mb-0">Filter List:</h5>
                                        <div class="widget-controls"> 
                                            <a data-widgster="close"class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                                        </div>  
                                        <div class="row">
                                            <div class="form-group col-md-2">
                                                <label>REGO:</label> 
                                                <input type="text" class="form-control form-control-sm" (keyup)="updateFilter(prefixFuel)" [(ngModel)]="filterFuelRego">
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label>Supplier:</label> 
                                                <select placeholder="Select" class="form-control form-control-sm" [(ngModel)]="filterFuelProvider" (change)="updateFilter(prefixFuel)"> 
                                                    <option selected disabled>Select..</option>
                                                    <option *ngFor="let pr of providers" value="{{pr.id}}">{{pr.company_name}}</option>
                                                </select>
                                            </div>

                                            <div class="form-group col-md-2">
                                                <label>Fuel Item Product:</label> 
                                                <select placeholder="Select" class="form-control form-control-sm" [(ngModel)]="filterFuelItemProduct" (change)="updateFilter(prefixFuel)"> 
                                                    <option selected disabled>Select..</option>
                                                    <option *ngFor="let type of fuel_type" value="{{type.name}}">{{type.name}}</option>
                                                </select>
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label>Fuel Litres:</label> 
                                                <input type="number" class="form-control form-control-sm" (keyup)="updateFilter(prefixFuel)" [(ngModel)]="filterLiter">
                                            </div>
                                            <div class="form-group col-md-2">
                                                <label>Fuel Cost:</label> 
                                                <input type="number" class="form-control form-control-sm" (keyup)="updateFilter(prefixFuel)" [(ngModel)]="filterCost">
                                            </div>

                                        </div>                                        
                                        <div class="row" *ngIf="!isFilterEmpty || fuelDateRange != ''">
                                            <div class="col-md-12">
                                                <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters(prefixFuel)">
                                                        <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>&nbsp;
                                                        <span >Reset Filters</span>
                                                </button> &nbsp;
                                            </div>
                                        </div>                                  
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br *ngIf="showFilters" />
                        <!-- end filter-->
                    
                        <!-- table and details -->
                        <div class="row pt-3">
                            <div [ngClass]="(showSidebar) ? 'col-md-8' : 'col-md-12'" align="left">
                                    <ngx-loading [show]="loadingIndicator"></ngx-loading>
                                    <span>
                                        Items: <span style="color: rgb(23, 98, 141);">{{ (totalFuels !== null) ?   (totalFuels) : "0"}}</span>   |  
                                        Total Litres: <span style="color: rgb(23, 98, 141);">{{ (totalFuelLitres !== null) ?   (totalFuelLitres | number:'1.2-2') : "0.00"}}</span>   |  
                                        Average Amount: <span style="color: rgb(23, 98, 141);">{{ (averageFuelAmount  && averageFuelAmount !== null) ?   '$' + (averageFuelAmount | number:'1.2-2') : "0.00"}}</span> |
                                        Total Amount: <span style="color: rgb(23, 98, 141);">{{ (totalFuelAmount  && totalFuelAmount !== null) ?   '$' + (totalFuelAmount | number:'1.2-2') : "0.00"}}</span>
                                    </span>
                                    <ngx-datatable
                                        [loadingIndicator]="loadingIndicator"
                                        class="material"
                                        [rows]="fuel_rows"
                                        [columnMode]="'force'"
                                        [columns]="fuel_columns"
                                        [footerHeight]="40"
                                        [rowHeight]="'auto'"
                                        [limit]="30"
                                        [selected]="selected"
                                        [selectionType]="'single'"
                                        (activate)="onActivate1($event)"
                                        (select)='onSelect1($event)'
                                        [scrollbarH]="true"
                                        >
                    
                                        <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="100" >
                                            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                                <div>
                                                    <a container="body" placement="top" title="Edit Fuel" (click)="openFuelModal(row)"><i
                                                            class="fa fa-lg fa-pencil"></i></a>&nbsp;
                                                    <a  (click)="openDeleteFuelModal(row)" placement="right" title="Delete Fuel"><i class="fa fa-lg fa-trash"></i></a>
                                                </div>
                                            </ng-template>
                                        </ngx-datatable-column>
                    
                                        <ngx-datatable-column name="Date" prop="date" headerClass="header" [width]="150" *ngIf="showDate">
                                                <ng-template let-value="value" ngx-datatable-cell-template>
                                                        {{ (value !== null) ? (value | date: 'dd MMM yyyy') : "No Data"  }}
                                                </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column name="Week #" headerClass="header" prop="week_no" [width]="150" *ngIf="showWeekNo"></ngx-datatable-column>
                                        <ngx-datatable-column name="REGO" headerClass="header" prop="rego" *ngIf="showRego && !fleet_id" [width]="150" ></ngx-datatable-column>
                                        <ngx-datatable-column name="Fleet ID" prop="fleet_id_num" headerClass="header" *ngIf="showFleetID && !fleet_id" [width]="120"></ngx-datatable-column>
                                        <ngx-datatable-column name="Driver" headerClass="header"  prop="driver_name" *ngIf="showDriver"></ngx-datatable-column>
                                        <ngx-datatable-column name="Supplier" prop="company_name" headerClass="header" [width]="120" *ngIf="showSupplier"></ngx-datatable-column>
                                        <ngx-datatable-column name="Card No." prop="card_no" headerClass="header" *ngIf="showCardNo"></ngx-datatable-column>
                                        <ngx-datatable-column name="Cost" prop="cost" headerClass="header-currency" align="right" *ngIf="showCost">
                                            <ng-template let-value="value" ngx-datatable-cell-template>
                                                <div align="right" style="padding-right:20px">{{ (value !== null) ?  '$' + (value | number:'1.2-2') : "No Price"}}</div>
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column name="Litres" prop="litres" headerClass="header" *ngIf="showLitres">
                                            <ng-template let-value="value" ngx-datatable-cell-template>
                                                <div align="right" style="padding-right:20px">{{value}} L</div>
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column name="File" prop="file"  headerClass="header" [width]="300" *ngIf="showFile">
                                            <ng-template let-value="value" ngx-datatable-cell-template>
                                                <a href="{{fileStoragePath}}/fuel/{{value}}" target="_new">{{value}}</a>
                                            </ng-template>
                                        </ngx-datatable-column>
                    
                                    </ngx-datatable>
                            </div>

                            <!-- FUEL DETAILS SIDEBAR -->
                            <div class="col-md-4" *ngIf="showSidebar">
                                <div widget class="card border-0 box-shadow selected-column">
                                    <div class="card-header transparent border-0 text-muted">
                                        <h5 class="mb-0">Fuel Details:</h5>
                                    </div>
                                    <div class="card-body pt-0 widget-body">
                                        <ul>
                                            <div *ngFor='let sel of selected, let i = index'>
                                                <div class="col-md-12 details">
                                                    Date: <strong>{{ sel.date | date: 'dd MMM yyyy' }}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                                    Week #: <strong>{{sel.week_no}}</strong><br />
                                                    <hr />
                                                    Fleet: <strong>{{sel.fleet_id_num}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                                    Rego: <strong>{{sel.rego}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                                                    Driver: <strong >{{sel.driver_name}}</strong><br />
                                                    <hr />
                                                    Company Name: <strong>{{sel.company_name}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <hr />
                                                    Fuel Card: {{sel.card_name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    Card Number: <strong>{{sel.card_no}}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    Receipt No.: <strong>{{sel.receipt_no}}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    Cost: <strong>$ {{sel.cost}}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />
                                                    Litre/s: <strong>{{sel.litres}}L</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    Odometer: <strong>{{sel.odometer}}</strong><br />
                                                    <hr />
                                                    Latitude: <strong>{{sel.lat}}</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Longitude: <strong>{{sel.lng}}</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    <br />Location: <strong>{{sel.location}}</strong><br />
                                                    <hr/>
                                                    Notes: <strong *ngIf = "sel.note">  {{sel.note}}</strong>
                                                        <strong *ngIf = "!sel.note">No notes.</strong><hr/><br />
                                                   
                                                    <h5 class="mb-0">Fuel Items:</h5>
            
                                                    <strong  *ngIf="sel.fuel_items?.length === 0">No items.</strong>
                                                    <div style="padding-top: 10px; padding-bottom: -30px;" class="table-responsive" *ngIf="sel.fuel_items?.length !== 0">
                                                        <table   class="table table-sm table-bordered">
                                                            <tr>
                                                                <th>Fuel Type</th>
                                                                <th>Quantity</th>
                                                                <th>Rate</th>
                                                                <th>GST</th>
                                                                <th>Total</th>
                                                                <th></th>
                                                            </tr>
                                                            <tr *ngFor = "let itm of sel.fuel_items, let n = index">
                                                                <td> {{sel.fuel_items[n].name}}</td>
                                                                <td> {{sel.fuel_items[n].quantity}}</td>
                                                                <td> {{sel.fuel_items[n].rate}}</td>
                                                                <td> 
                                                                    <i class="fa fa-check-circle-o" *ngIf="sel.fuel_items[n].gst == '1'"></i>
                                                                </td>
                                                                <td>{{sel.fuel_items[n].total}}</td>
                                                                <td>
                                                                    <a *ngIf="sel.fuel_items?.length > 1" placement="right" title="Delete Item" (click)="openDeleteItemModal(sel.fuel_items[n])" ><i
                                                                        class="fa fa-lg fa-trash"></i></a>
                                                                </td>
                                                            </tr>
                                                        </table> 
                                                    </div>
                                                </div><br />
                                                <div class="col-md-12">
                                                    <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openFuelModal(sel)">
                                                        <span class="badge badge-pill badge-white text-primary ml-1"><i
                                                                class="fa fa-lg fa-pencil"></i></span>
                                                        Edit
                                                    </button> &nbsp;
                                                    <button type="button" class="btn btn-sm btn-danger mb-1"
                                                        (click)="openDeleteFuelModal(sel)">
                                                        <span class="badge badge-pill badge-white text-primary ml-1"><i
                                                                class="fa fa-lg fa-trash"></i></span>
                                                        Delete
                                                    </button>
                                                    &nbsp;
                                                    <button *ngIf="!!sel.file" type="button" class="btn btn-sm btn-secondary mb-1">
                                                        <span class="badge badge-pill badge-white text-primary ml-1"><i
                                                            class="fa fa-lg fa-file"></i></span>&nbsp;
                                                        <a  href="{{fileStoragePath}}/fuel/{{sel.file}}" target="_new" style="text-decoration: none; color: white;">View File</a>
                                                    </button>
                                                </div>
                                            </div>
                                            <li *ngIf="!selected.length">No Selections</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <!--  END FUEL DETAILS SIDEBAR  -->
                        </div>
                        <!-- end table-->
                    </div>
                </div>
            </div>
            <!-- END TAB A -->
            <!-- TAB B -->
            <div class="tab-pane" id="tabItems">
                 <!--Feature Menu Icon-->
                 <div class="row pt-0">
                    <div class="col-md-12">
                        <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1"   (click)="printer.printWithHeaderFooter('print-section-items', 'Fuel Items List')" placement="bottom" [disabled]="itemCount < 1"
                            ngbTooltip="Print List">
                            <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
                        </button>

                        <div class="btn-group mr-1">
                            <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="itemCount < 1">
                                <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                            </button>
                            <div class="dropdown-menu fs-12">
                                <a (click)="fuelItems_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                                <a (click)="fuelItems_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                                <a (click)="fuelItems_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                            </div>
                        </div>

                        <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                            (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                           <i class="fa fa-lg fa-filter"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
                        </button>
            
                        <div class="btn-group mb-1">
                            <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                placement="bottom" ngbTooltip="Show/Hide Columns">
                                <span class="sr-only">Toggle Dropdown</span>
                                <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                            </button>
                            <div class="dropdown-menu fs-12" style="width: 150px;">
                                <div class="col-md-12 mb-3 fs-12">
                                    <input type="checkbox" [(ngModel)]="showDateCreated"> Date Created<br />
                                    <input type="checkbox" [(ngModel)]="showFuelItems_WeekNo"> Week No.<br />
                                    <input type="checkbox" [(ngModel)]="showFuelItems_FuelID"> Fuel ID<br />
                                    <input type="checkbox" [(ngModel)]="showFuelItems_Rego"> REGO<br />
                                    <input type="checkbox" [(ngModel)]="showFuelItems_FleetID"> Fleet ID<br />
                                    <input type="checkbox" [(ngModel)]="showProduct"> Product<br /> 
                                    <input type="checkbox" [(ngModel)]="showRate"> Rate<br />
                                    <input type="checkbox" [(ngModel)]="showQuantity"> Quantity<br />
                                    <input type="checkbox" [(ngModel)]="showTotal"> Total<br />
                                </div>
                            </div>
                        </div>

                        <span *ngIf="fuelItemDateDropdown=='range'" class="pull-right" >&nbsp;
                            <input type="text"   width="120" class="mb-1" class="dateRangeInput" matInput
                            ngxDaterangepickerMd
                            [locale]="locale"
                            startKey="start"
                            endKey="end"
                            [showWeekNumbers]="true"
                            [showDropdowns]="true"
                            [(ngModel)]="fuelItemDateRange"
                            (ngModelChange)="processFuelItemDateRange($event)"
                            name="daterange2" 
                            [autoApply]="true"
                            opens="left"
                            drops="down"
                            [maxDate]="maxDate"
                            />
                        </span>

                        <select [(ngModel)]="fuelItemDateDropdown" (ngModelChange)="onChangeFuelItemDateDropdown($event)" class="dateFilter btn btn-sm  btn-secondary mb-1 pull-right">
                            <option value="today">Today</option>
                            <option value="week">This Week</option>
                            <option value="month">This Month</option>
                            <option value="year">This Year</option>
                            <option value="7">Last 7 days</option>
                            <option value="14">Last 14 days</option>
                            <option value="30">Last 30 days</option>
                            <option value="90">Last 90 days</option>
                            <option value="all">All Dates</option>
                            <option value="range">Custom date range</option>
                        </select>
                    </div>
                </div>
                <br *ngIf="showFilters" />
                <div class="row"  *ngIf="showFilters">
                    <div class="col-md-12">
                        <div widget class="card border-0 box-shadow">
                            <div class="card-header border-0 text-muted">
                                <h5 class="mb-0">Search Item List:</h5>
                                <div class="widget-controls"> 
                                    <a data-widgster="close" class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                                </div>  
                            </div>
                            
                            <div class="card-block card-header pt-0 widget-body">
                                <div class="row">
                                    <div class="col-md-2">
                                        <label>Fuel ID:</label> 
                                        <input type="text" class="form-control form-control-sm" (keyup)="updateFilter(prefixItem)" [(ngModel)]="filterItemFuelId">
                                    </div>

                                    <div class="col-md-2">
                                        <label>Cost:</label> 
                                        <input type="text" class="form-control form-control-sm" (keyup)="updateFilter(prefixItem)" [(ngModel)]="filterItemCost">
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label>Product:</label> 
                                        <select placeholder="Select" class="form-control form-control-sm" [(ngModel)]="filterItemProduct" (change)="updateFilter(prefixItem)"> 
                                            <option selected disabled>Select..</option>
                                            <option *ngFor="let type of fuel_type" value="{{type.id}}">{{type.name}}</option>
                                        </select>
                                    </div>
                                </div>

                                <br />
                                <div class="row" *ngIf="!isFilterEmpty">
                                    <div class="col-md-12">
                                        <button  type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters(prefixItem)">
                                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>
                                                <span >Reset Filters</span>
                                        </button> &nbsp;
                                    </div>          
                                </div>                                  
                            </div>
                        </div>
                    </div>
                </div>
                <br *ngIf="showFilters" /><br/>
                <div class="row  pt-0">
                    <div class="col-md-12">
                        <ngx-loading [show]="loadingIndicator2"></ngx-loading>
                        <span>
                            Items: <span style="color: rgb(23, 98, 141);">{{ (totalFuelItems && totalFuelItems > 0) ?   (totalFuelItems) : "0"}}</span>   |  
                            Total Litres: <span style="color: rgb(23, 98, 141);">{{ (totalFuelItemLitres !== null) ?   (totalFuelItemLitres | number:'1.2-2') : "0.00"}}</span>   |  
                            Average Amount: <span style="color: rgb(23, 98, 141);">{{ (averageFuelItemAmount  && averageFuelItemAmount !== null) ?   '$' + (averageFuelItemAmount | number:'1.2-2') : "0.00"}}</span> |
                            Total Amount: <span style="color: rgb(23, 98, 141);">{{ (totalFuelItemAmount !== null) ?   '$' + (totalFuelItemAmount | number:'1.2-2') : "0.00"}}</span>
                        </span>
                        <ngx-datatable  
                            class="material"
                            [rows]="fuelData"
                            [columnMode]="'force'"
                            [columns]="items_columns"
                            [footerHeight]="30"
                            [rowHeight]="'auto'"
                            [limit]="30"
                            [selected]="selected2"
                            [selectionType]="'single'"
                            (activate)="onActivate1($event)"
                            (select)='onSelect1($event)'
                            [scrollbarH]="true">

                            <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="80">
                                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                                    <div>
                                        <a placement="right" title="Delete Item" (click)="openDeleteItemModal(row)" ><i
                                        class="fa fa-lg fa-trash"></i></a>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Date" prop="date" headerClass="header" *ngIf="showDateCreated">
                                <ng-template let-value="value" ngx-datatable-cell-template>
                                    {{ (value !== null) ? (value | date: 'dd MMM yyyy') : "No Data"  }}
                            </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Week No" prop="week_no" headerClass="header" *ngIf="showFuelItems_WeekNo">
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Fuel ID" prop="fuel_id" headerClass="header" *ngIf="showFuelItems_FuelID">
                            </ngx-datatable-column>
                            <span *ngIf="showFuelItems_Rego">
                            <ngx-datatable-column *ngIf="!this.fleet_id" name="REGO" prop="rego" headerClass="header" >
                            </ngx-datatable-column></span>
                            <span *ngIf="showFuelItems_FleetID">
                            <ngx-datatable-column *ngIf="!this.fleet_id" name="Fleet ID" prop="fleet_id_num" headerClass="header" >
                            </ngx-datatable-column></span>
                            <ngx-datatable-column name="Product" prop="name" headerClass="header" *ngIf="showProduct">
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Rate ($)" prop="rate" headerClass="header" *ngIf="showRate">
                                <ng-template let-value="value" ngx-datatable-cell-template>
                                    <div align="right" style="padding-right:20px">{{ (value !== null) ?  '$' + (value | number:'1.2-2') : "No Price"}}</div>
                                </ng-template>
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Quantity" prop="quantity" headerClass="header" *ngIf="showQuantity">
                            </ngx-datatable-column>
                            <ngx-datatable-column name="Total" prop="total" headerClass="header" *ngIf="showTotal">
                                <ng-template let-value="value" ngx-datatable-cell-template>
                                    <div align="right" style="padding-right:20px">{{ (value !== null) ?   '$' + (value | number:'1.2-2') : "No Price"}}</div>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div><!-- END TAB A -->
        </div>    
    </div>
</div>

<!-- START PRINT-->
    <!-- FUEL -->
    <div id="print-section-fuel" style="display:none">
        <table style="width:100%" class="table table-striped">
            <thead>
              <tr><th><div class="header-space">&nbsp;</div></th></tr>
              <tr class="thead2">
                <th align="left" *ngIf="showWeekNo">WEEK NUMBER</th>
                <th align="left" *ngIf="showDate">DATE</th>
                <th align="left" *ngIf="showRego">REGO</th>
                <th align="left" *ngIf="showFleetID">FLEET ID</th>
                <th align="left" *ngIf="showDriver">DRIVER</th>
                <th align="left" *ngIf="showSupplier">SUPPLIER</th>
                <th align="left" *ngIf="showCardNo">CARD #</th>
                <th align="left" *ngIf="showLitres">LITRES</th>
                <th align="left" *ngIf="showCost">COST</th>
                <th align="left" *ngIf="showFile">FILE</th>
            </tr>   
            </thead>
           
            <tbody>
                <tr *ngFor="let row of fuel_rows" nobr="true">
                    <td *ngIf="showWeekNo">{{row.week_no}}</td>
                    <td *ngIf="showDate">{{ (row.date !== null) ? (row.date | date: 'dd MMM yyyy') : "No Data"  }}</td>
                    <td *ngIf="showRego">{{row.rego}}</td>
                    <td *ngIf="showFleetID">{{row.fleet_id_num}}</td>
                    <td *ngIf="showDriver">{{row.driver_name}}</td>
                    <td *ngIf="showSupplier">{{row.company_name}}</td>
                    <td *ngIf="showCardNo">{{row.card_no}}</td>
                    <td *ngIf="showLitres">{{row.litres}} L</td>
                    <td *ngIf="showCost">{{(row.cost!==null)? '$' + (row.cost| number:'1.2-2') : "No Price"}}</td>
                    <td *ngIf="showFile">{{row.file}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>
                        <div class="footer-space">&nbsp;</div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>

    <!-- FUEL ITEMS-->
    <div id="print-section-items" style="display:none">
        <table style="width:100%"class="table table-striped">
            <thead>
                <tr><th><div class="header-space">&nbsp;</div></th></tr>
                <tr class="thead2">
                    <th align="left" *ngIf="showDateCreated">DATE CREATED</th>
                    <th align="left" *ngIf="showFuelItems_WeekNo">WEEK NO.</th>
                    <th align="left" *ngIf="showFuelItems_FuelID">FUEL ID</th>
                    <th align="left" *ngIf="showFuelItems_Rego">REGO</th>
                    <th align="left" *ngIf="showFuelItems_FleetID">FLEET ID</th>
                    <th align="left" *ngIf="showProduct">PRODUCT</th>
                    <th align="left" *ngIf="showRate">RATE</th>
                    <th align="left" *ngIf="showQuantity">QUANTITY</th>
                    <th align="left" *ngIf="showTotal">TOTAL</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of fuelData" nobr="true">  
                    <td *ngIf="showDateCreated">{{ (row.created_at !== null) ? (row.created_at | date: 'dd MMM yyyy') : "No Data"  }}</td>
                    <td *ngIf="showFuelItems_WeekNo">{{row.week_no}}</td>
                    <td *ngIf="showFuelItems_FuelID">{{row.fuel_id}}</td>
                    <td *ngIf="showFuelItems_Rego">{{row.rego}}</td>
                    <td *ngIf="showFuelItems_FleetID">{{row.fleet_id_num}}</td> 
                    <td *ngIf="showProduct">{{row.name}}</td>
                    <td *ngIf="showRate">{{ (row.rate !== null) ?  '$' +(row.rate | number:'1.2-2') : "No Price"}}</td>
                    <td *ngIf="showQuantity">{{row.quantity}}</td>
                    <td *ngIf="showTotal">{{ (row.total !== null) ?  '$' +(row.total | number:'1.2-2') : "No Price"}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>
                        <div class="footer-space">&nbsp;</div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
<!-- END PRINT-->

<!-- START OF DELETE FUEL FORM -->
<ng-template #modalDeleteFuel let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Fuel Cost</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row">
            <div class="col-md-12">
                Do you really want to delete this fuel cost?
            </div>
        </div>
    </div>

    <div class="modal-footer">
        
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteFuel(fuel)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE FUEL FORM -->

<!-- START OF DELETE ITEM FORM -->
<ng-template #modalDeleteItem let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete Item</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row">
            <div class="col-md-12">
               Do you really want to delete this item?
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteItem(item)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE ITEM FORM -->

<!-- START OF ADD FUEL FORM -->
<ng-template #modalFuel let-close="close">
    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isEditMode">Edit Fuel Cost</h5>
        <h5 class="modal-title" *ngIf="!isEditMode">Add Fuel Cost</h5>
        <button type="button" class="close" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="fuelForm" novalidate (ngSubmit)="onSubmitFuel(fuelForm.value)">
        <div class="modal-body">
            <div class="row">
                <div class="form-group col-md-3">
                    <h6>Date<span class="text-danger">*</span> :</h6>
                    <input formControlName="date" class="form-control form-control-sm" type="date" max="{{dateNow|date:'yyyy-MM-dd'}}" onkeydown="return false" (change)="toggleSubForm()" required>
                    <div *ngIf="fuelForm.controls.date.touched">
                        <div *ngIf="fuelForm.controls.date.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-3"> 
                    <h6>Time<span class="text-danger">*</span> :</h6>
                     <ngb-timepicker formControlName="time_string" [meridian]="true"></ngb-timepicker>
                </div>
                 <div class="form-group col-md-3">
                    <h6>Fleet<span class="text-danger">*</span> :</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="fleet_id" (change)="toggleSubForm();assignRego()"required>
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let fl of fleet" value="{{fl.id}}">{{fl.rego}}</option>
                    </select>
                    <div *ngIf="fuelForm.controls.fleet_id.touched">
                        <div *ngIf="fuelForm.controls.fleet_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-3">
                    <h6>Provider<span class="text-danger">*</span> :</h6>
                    <select class="form-control form-control-sm" placeholder="Select" formControlName="provider_id" (change)="toggleSubForm()" required>
                        <option selected *ngIf="isEditMode==false" disabled>Select..</option>
                        <option *ngFor="let pr of providers" value="{{pr.id}}">{{pr.company_name}}</option>
                    </select>
                    <div *ngIf="fuelForm.controls.provider_id.touched">
                        <div *ngIf="fuelForm.controls.provider_id.errors?.required">
                            <small class="text-danger" >This field is required.</small>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="showSubForm || isEditMode">
                <div class="row">
                    <div class="form-group col-md-4">
                        <h6>Driver<span class="text-danger">*</span> :</h6>
                        <select  class="form-control form-control-sm" placeholder="Select" formControlName="driver_id" (change)="assignDriverName()">
                            <option disabled selected *ngIf="isEditMode==false">Select..</option>
                            <option *ngFor="let dr of drivers" value="{{dr.id}}" [disabled]="checkDriverStatus(dr.user_status)">{{dr.full_name}}</option>
                        </select>
                        <div *ngIf="fuelForm.controls.driver_id.touched">
                            <div *ngIf="fuelForm.controls.driver_id.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-4">
                        <h6>Manifest:</h6>
                        <div class="input-group d-flex align-items-center">
                            <select  class="form-control form-control-sm" placeholder="Select" formControlName="manifest_id" (change)="populateJob()">
                                <option value="null" [selected]="isEditMode==false || getCtrlValue('manifest_id') ==null || getCtrlValue('manifest_id') ==''">Select..</option>
                                <option *ngFor="let m of manifests" [attr.value]="m.manifest_id" [selected]="getCtrlValue('manifest_id') == m.manifest_id">{{m.manifest_job}}</option>
                            </select>
                            <i (click)="resetFormControl('manifest_id')" ngbTooltip="Clear Manifest" class="fa fa-eraser ml-2" aria-hidden="true"></i>
                        </div>
                        </div>  
                    <div class="col-md-4">
                        <div class="form-group">
                            <h6 for="input-1">Receipt No :</h6>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend"><div class="input-group-text">#</div></div>
                                <input type="text" class="form-control form-control-sm" formControlName="receipt_no">
                            </div>
                        </div>
                    </div>            
                </div>
                <div class="row">
                    <div class="form-group col-md-3">
                        <h6 for="input-1">Odometer<span class="text-danger">*</span> :</h6>
                        <div class="input-group input-group-sm">
                            <input type="number" class="form-control form-control-sm" formControlName="odometer">
                        </div>
                        <div *ngIf="fuelForm.controls.odometer.touched">
                            <div *ngIf="fuelForm.controls.odometer.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="fuelForm.controls.odometer.errors?.pattern">
                                <small class="text-danger">This field requires numeric values only.</small>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <h6 for="input-1">Location<span class="text-danger">*</span> :</h6>
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control form-control-sm" formControlName="location">
                        </div>
                        <div *ngIf="fuelForm.controls.location.touched">
                            <div *ngIf="fuelForm.controls.location.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <h6>Fuel Card :</h6>
                            <div class="input-group d-flex align-items-center">
                                <select class="form-control form-control-sm" placeholder="Select" formControlName="fuel_card_id">
                                    <option value="null" [selected]="isEditMode==false || getCtrlValue('fuel_card_id') ==null || getCtrlValue('fuel_card_id') =='' ">Select..</option>
                                    <option *ngFor="let fl of fuel_cards_all" [attr.value]="fl.id" [selected]="getCtrlValue('fuel_card_id') == fl.id" [disabled]="checkCardValidity(fl.id)">{{fl.card_name}} - {{fl.card_no}}</option>
                                </select>
                                <i (click)="resetFormControl('fuel_card_id')" ngbTooltip="Clear Fuel" class="fa fa-eraser ml-2" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>  
                </div>

                <div class = "row">
                    <div class="col-md-6">
                        <div class="form-group" *ngIf ="(fileExists==true)">
                            <h6>Image File<span class="text-danger">*</span> :</h6><small><i>(jpg, jpeg, png ...)</i></small><br/>
                            <label>{{fuel?.docket_file}}</label> <button class="btn btn-primary" type="button" (click)="removeFile(prefixFuel)">Remove File</button>
                        </div>
                        <div class="form-group" *ngIf ="(fileExists==false)">
                            <h6>Image File<span class="text-danger">*</span><small><i>(.jpg, .jpeg, .png, .gif ...)</i></small> :</h6>
                            <app-file-uploader (passFile)="getFile($event, prefixFuel)"></app-file-uploader>
                        </div>
                    </div> 
                    <div class="col-md-6">
                        <div class="form-group">
                            <h6 for="input-1">Notes:</h6>
                            <textarea class="form-control form-control-sm" formControlName="note" rows="4" cols="50"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            
            <div>
                <div *ngIf="(tempItems?.length !== 0)">
                    <div class="form-group">
                        <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>Fuel Type</th>
                                    <th>Litres</th>
                                    <th>Price</th>
                                    <th>GST</th>
                                    <th>Total</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor = "let item of tempItems, let n = index ">
                                    <ng-container value ="item.fuel_type_id" *ngFor="let ty of fuel_type">
                                        <td *ngIf="ty.id==item.fuel_type_id">{{ty.name}}</td>
                                    </ng-container>
                                    <td> {{item.quantity}}</td>
                                    <td> {{item.rate}}</td>
                                    <td>
                                        <i class="fa fa-check-circle-o" *ngIf="item.gst == 1"></i>
                                    </td>
                                    <td> {{item.total| number: '1.2-2'}}</td>
                                    <td>
                                        <a *ngIf="tempItems.length > 1 || isEditMode == false" placement="right" title="Delete Fuel Item" (click)="removeItem(n)" ><i
                                            class="fa fa-lg fa-trash"></i></a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div *ngIf="tempItems?.length === 0" style="text-align: center;"><i>No items to display</i></div>
                        <hr>
                        <table class="col-md-6">
                            <tr> 
                                <td><strong>Total Liter: <span style="color:red;font-weight:bold;font-style:italic;">{{grandLiter  | number:'1.2-2'}}</span> L</strong></td>
                                <td><strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong></td>
                                <td><strong>Grand Total: $ <span style="color:red;font-weight:bold;font-style:italic;">{{grandTotal  | number:'1.2-2'}}</span></strong></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <button type="button" [ngClass]="(showItem)?'mr-auto btn btn-sm btn-danger':'mr-auto btn btn-sm btn-success'" (click)="toggleItem()" >
                <span *ngIf="!showItem" >Add New Item</span>
                <span *ngIf="showItem" >Close Add Item</span>
            </button>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="!isEditMode" type="submit" class="btn btn-sm btn-success"  [disabled]="!fuelForm.valid || spinner == true">Save</button>
            <button *ngIf="isEditMode" type="submit" class="btn btn-sm btn-success"  [disabled]="!fuelForm.valid || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="closeModal()">Cancel</button>
        </div>
    </form>
    <!--Add New Item Form-->
    <div *ngIf="showItem" >
        <hr>
        <form [formGroup]="itemForm" novalidate (ngSubmit)="onSubmitItem(itemForm.value)">
            <div class="col-md-6">
                <h5 class="modal-title" >Add New Item</h5>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Fuel Type<span class="text-danger">*</span> :</label>
                            <select class="form-control form-control-sm" placeholder="Select" formControlName="fuel_type_id" required>
                                <option *ngFor="let type of fuel_type" value="{{type.id}}">{{type.name}}</option>
                            </select>
                            <div *ngIf="itemForm.controls.fuel_type_id.touched">
                                <div *ngIf="itemForm.controls.fuel_type_id.errors?.required">
                                    <small class="text-danger" >This field is required.</small>
                                </div>
                            </div>
                        </div> 
                    </div>
                    <div class="col-md-4">
                        <label>Litres<span class="text-danger">*</span> :</label>
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control form-control-sm" formControlName="quantity" required>
                            <div class="input-group-append"><div class="input-group-text">L</div></div>
                        </div>
                        <div *ngIf="itemForm.controls.quantity.touched">
                            <div *ngIf="itemForm.controls.quantity.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="itemForm.controls.quantity.errors?.pattern">
                                <small class="text-danger">Quantity must have a valid numeric value.</small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label>Total Price<span class="text-danger">*</span> :</label>
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend"><div class="input-group-text">$</div></div>
                            <input type="text" class="form-control form-control-sm" formControlName="total" required>
                        </div>
                        <div *ngIf="itemForm.controls.total.touched">
                            <div *ngIf="itemForm.controls.total.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="itemForm.controls.total.errors?.pattern">
                                <small class="text-danger">Total price must have a valid currency value.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
                <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                <button class="btn btn-sm btn-success" type="submit" [disabled]="!itemForm.valid || spinner == true" >Save & Add Another</button>
                <button class="btn btn-sm btn-secondary" (click)="toggleItem()"> Cancel</button>
            </div>    
            <!-- End of Add New Item-->    
        </form>
    </div>
</ng-template>
<!-- END OF MODAL ADD FUEL FORM -->




